'use client'

import { useTranslations } from 'next-intl'
import SectionHeader from './section-header'

export default function SustainabilityFocus() {
  const t = useTranslations('page_cam_ket_phat_trien')
  return (
    <div id='item-5-content'>
      <SectionHeader number='05' title={t('focus.title')} />
      <div className='grid gap-5'>
        <div className='space-y-4 rounded-2xl bg-neutral-50'>
          <picture style={{ width: '100%' }}>
            <source
              srcSet='https://media.coolmate.me/image/November2024/mceclip11_13.png'
              media='(max-width: 768px)'
            />
            <img
              src='https://media.coolmate.me/image/November2024/mceclip9_67.png'
              className='w-full rounded-2xl'
              alt={t('focus.image_alt')}
            />
          </picture>
          <div className='p-5 pb-9'>
            <h3 className='mb-3 font-criteria text-lg font-medium md:text-xl'>
              {t('focus.card_title')}
            </h3>
            <p className='text-black-70 text-base'>
              {t('focus.card_description')}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
